"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@dc/ui/components";
import { addToast } from "@dc/ui/hooks/addToast";
import { useRollbar } from "@rollbar/react";
import { useTranslations } from "next-intl";
import { useEffect, useRef } from "react";
import type Rollbar from "rollbar";
import { useRollbarEnabled } from "@/app/providers/RollbarProvider/RollbarProvider";
import { useAppVersionCheck } from "@/hooks/useAppVersionCheck/useAppVersionCheck";

/**
 * Tells the user a deploy landed while they were working. Next will force a
 * full reload on their next navigation regardless, so the toast is persistent:
 * it lets them choose the moment instead of losing state on a random click.
 */
export function NewVersionToast() {
  return useRollbarEnabled() ? <ReportingNewVersionToast /> : <NewVersionToastEffect />;
}
function ReportingNewVersionToast() {
  const $ = _c(2);
  const rollbar = useRollbar();
  let t0;
  if ($[0] !== rollbar) {
    t0 = <NewVersionToastEffect rollbar={rollbar} />;
    $[0] = rollbar;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function NewVersionToastEffect(t0) {
  const $ = _c(7);
  const {
    rollbar
  } = t0;
  const t = useTranslations("app_version");
  const {
    isStale,
    currentVersion,
    latestVersion
  } = useAppVersionCheck();
  const shownRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== currentVersion || $[1] !== isStale || $[2] !== latestVersion || $[3] !== rollbar || $[4] !== t) {
    t1 = () => {
      if (!isStale || shownRef.current) {
        return;
      }
      shownRef.current = true;
      rollbar?.info("New app version available", {
        currentVersion,
        latestVersion
      });
      addToast({
        title: t("new_version_title"),
        description: t("new_version_description"),
        color: "primary",
        timeout: 0,
        endContent: <Button size="sm" color="primary" onPress={_temp}>{t("reload")}</Button>
      });
    };
    t2 = [isStale, currentVersion, latestVersion, rollbar, t];
    $[0] = currentVersion;
    $[1] = isStale;
    $[2] = latestVersion;
    $[3] = rollbar;
    $[4] = t;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  return null;
}
function _temp() {
  return window.location.reload();
}